// src/utils/downloadPdf.js
import api from '../services/api'

export const downloadPdf = async (url) => {
  // Extrai só o nome do arquivo da URL que o backend retornou
  const fileName = url.split('/').pop()

  try {
    const response = await api.get(`/reports/download/${fileName}`, {
      responseType: 'blob',
    })

    const blobUrl = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName || 'relatorio.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
  } catch (e) {
    console.error('Falha ao baixar relatório:', e)
    throw e
  }
}